import {defineStyleConfig} from '@chakra-ui/styled-system'

export default defineStyleConfig({
  baseStyle: {
    maxW: '7xl',
    px: {base: '4', md: '8'}
  }
})
